import { Box, Icon } from "@nubeteck/components";
import {
  Alert,
  Button,
  Collapse,
  Dropdown,
  Flex,
  Form,
  FormInstance,
  Image,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { FlexStyled } from "../registration/register-confirmation/confirmation.styled";
import { ColumnsType } from "antd/es/table";
import { IActivity } from "src/Interfaces/teacherCourses";
import { Table } from "antd/lib";
import { CardStyled } from "../custom/cards/card.styled";
import {
  FlexFiltersContainer,
  MediumDrawer,
  SectionTitle,
} from "src/pages/teacher-pages/course-detail/course-detail.styled";
import { useNavigate } from "react-router-dom";
import { SmallHeadingStyled } from "../custom/texts/texts.styled";
import { NoResultsSVG } from "src/assets";
import TextArea from "antd/es/input/TextArea";
import {
  useCreateCourseActivityMutation,
  useCreateMoodleUrlMutation,
  useDeleteActivityMutation,
  useGetActivitiesFromMoodleMutation,
  useGetActivityByIdMutation,
  useGetActivityDefaultValuesMutation,
  useGetActivityTypesMutation,
  useUpdateActivityPointsMutation,
  useUpdateCourseActivityMutation,
} from "src/services";
import toast from "react-hot-toast";
import {
  toastErrorStyle,
  useSuccessRegisterToast,
  toastWarningStyle,
  useSuccessPointsUpdatedToast,
  useSuccessActivityRemovedToast,
} from "src/constants";
import { ArrayUtils } from "@nubeteck/utils";
import { editableComponents } from "../custom/editable-table-items/editable-table-items";
import { ButtonAlternativeStyled } from "../custom/buttons/buttons.styled";
import { getCourseDetailPage } from "src/Api/content";
import { useLocale } from "src/i18n/localeContext";
import { StrapiError } from "src/pages/StrapiError";

function ActivitiesList({
  isLoading,
  data,
  seccionId,
  getData,
  editable,
}: {
  isLoading: boolean;
  data: { actividades: IActivity[]; totalPuntosPosibles: number };
  seccionId: number;
  editable: boolean;
  getData: ({
    seccionId,
    titulo,
    tipoId,
  }: {
    seccionId: number;
    titulo: string;
    tipoId: number;
  }) => void;
}) {
  const { locale } = useLocale();
  const [courseDetailPage, setCourseDetailPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState(false);

  const [drawerActivitiesOpen, setDrawerActivitiesOpen] = useState(false);
  const [actividadId, setActividadId] = useState(0);
  const [tituloFiltro, setTituloFiltro] = useState("");
  const [tipoIdFiltro, setTipoIdFiltro] = useState(0);
  const showSuccessToast = useSuccessRegisterToast();
  const showSuccessPointsUpdatedToast = useSuccessPointsUpdatedToast();
  const showSuccessActivityRemovedToast = useSuccessActivityRemovedToast();
  const [actividadesPuntosPosibles, setActividadesPuntosPosibles] = useState<IActivity[]>([]);
  const [totalPuntosPosibles, setTotalPuntosPosibles] = useState(0);
  const [isEditingPuntosPosibles, setIsEditingPuntosPosibles] = useState(false);
  const [recursoMoodle, setRecursoMoodle] = useState("");
  const [oldMoodleActivityList, setOldMoodleActivityList] = useState([]);
  const [seccionMoodle, setSeccionMoodle] = useState(0);

  const isEditingRef = React.useRef(isEditingPuntosPosibles);

  const [
    createActivity,
    {
      isError: isErrorCreate,
      isSuccess: isSuccessCreate,
      isLoading: isLoadingCreate,
      error: errorCreate,
    },
  ] = useCreateCourseActivityMutation();

  const [
    updateActivity,
    {
      isError: isErrorUpdate,
      isSuccess: isSuccessUpdate,
      isLoading: isLoadingUpdate,
      error: errorUpdate,
    },
  ] = useUpdateCourseActivityMutation();
  const [
    deleteCourseActivity,
    {
      isError: isErrorDelete,
      isSuccess: isSuccessDelete,
      isLoading: isLoadingDelete,
      error: errorDelete,
    },
  ] = useDeleteActivityMutation();
  const [
    updatePoints,
    {
      isError: isErrorUpdatePoints,
      isSuccess: isSuccessUpdatePoints,
      isLoading: isLoadingUpdatePoints,
      error: errorUpdatePoints,
    },
  ] = useUpdateActivityPointsMutation();
  const [getActivityTypes, { data: activityTypes }] = useGetActivityTypesMutation();
  const [getActivityDefaultValues, { data: defaultValues }] = useGetActivityDefaultValuesMutation();
  const [getActivitiesMoodle, { data: activitiesMoodle, isLoading: isLoadingActivitiesMoodle }] =
    useGetActivitiesFromMoodleMutation();
  const [createMoodleUrl, { data: moodleUrl, isLoading: isLoadingMoodleUrl }] =
    useCreateMoodleUrlMutation();
  const [getActivityById, { data: activityById, isLoading: isLoadingById }] =
    useGetActivityByIdMutation();

  const [form] = Form.useForm<IActivity>();
  const formRef = React.useRef<FormInstance>(null);
  // const campoSiempreDisponible = Form.useWatch("esSiempreDisponible", form);

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const tiposActividades = ArrayUtils.selectLabelValue(
    activityTypes ?? [],
    "actividadTipoNombre",
    "actividadTipoId",
  );

  const valoresDefaultTipos = ArrayUtils.selectLabelValue(
    defaultValues?.tipos,
    "actividadTipoNombre",
    "actividadTipoId",
  );
  const valoresDefaultRecursos = ArrayUtils.selectLabelValue(
    defaultValues?.recursos,
    "recursoNombre",
    "recursoId",
  );
  const valoresDefaultSemanas = ArrayUtils.selectLabelValue(
    defaultValues?.semanas,
    "semanaNombre",
    "semanaId",
  );
  const activitiesMoodleOptions = ArrayUtils.selectLabelValue(
    activitiesMoodle,
    "actividadMoodleNombre",
    "actividadMoodleId",
  );

  const [modal, contextHolder] = Modal.useModal();
  const navigate = useNavigate();

  useEffect(() => {
    form.setFieldValue("actividadMoodleId", null);
    getActivitiesMoodle({ seccion: seccionMoodle, curso: seccionId, name: recursoMoodle });
    createMoodleUrl({ seccion: seccionMoodle, curso: seccionId, name: recursoMoodle });
  }, [seccionMoodle, recursoMoodle, getActivitiesMoodle, seccionId, createMoodleUrl, form]);

  useEffect(() => {
    if (activitiesMoodle?.length > oldMoodleActivityList?.length) {
      form.setFieldValue(
        "actividadMoodleId",
        activitiesMoodle[activitiesMoodle?.length - 1].actividadMoodleId,
      );
    }
  }, [activitiesMoodle, oldMoodleActivityList, form]);

  useEffect(() => {
    getData({ seccionId, titulo: tituloFiltro, tipoId: tipoIdFiltro });
  }, [
    getData,
    tipoIdFiltro,
    tituloFiltro,
    seccionId,
    isSuccessCreate,
    isSuccessUpdate,
    isSuccessDelete,
    isSuccessUpdatePoints,
  ]);

  useEffect(() => {
    getActivityTypes();
    getActivityDefaultValues(seccionId);
  }, [getActivityTypes, getActivityDefaultValues, seccionId]);

  // keep the value in isToggledRef actual
  // when isToggled changes, isToggledRef is updated accordingly
  useEffect(() => {
    isEditingRef.current = isEditingPuntosPosibles;
  }, [isEditingPuntosPosibles]);

  useEffect(() => {
    setActividadesPuntosPosibles(data?.actividades);
  }, [data]);

  useEffect(() => {
    setTotalPuntosPosibles(data?.totalPuntosPosibles);
  }, [data]);

  useEffect(() => {
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        getActivitiesMoodle({ seccion: seccionMoodle, curso: seccionId, name: recursoMoodle });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seccionMoodle, recursoMoodle]);

  useEffect(() => {
    if (actividadId && actividadId !== 0) {
      getActivityById(actividadId);
    }
  }, [actividadId, getActivityById]);

  useEffect(() => {
    if (activityById) {
      form.setFieldsValue(activityById);
      setDrawerActivitiesOpen(true);
    }
  }, [activityById, form]);

  useEffect(() => {
    setDrawerActivitiesOpen(false);
    if (isErrorCreate) toast.error(errorCreate?.data?.detail, toastErrorStyle);

    if (isSuccessCreate) {
      showSuccessToast();
    }
    form.resetFields();
    setActividadId(0);
  }, [isSuccessCreate, form, isErrorCreate, errorCreate, showSuccessToast]);

  useEffect(() => {
    setDrawerActivitiesOpen(false);
    if (isErrorUpdate) toast.error(errorUpdate?.data?.detail, toastErrorStyle);

    if (isSuccessUpdate) {
      showSuccessToast();
    }
    setActividadId(0);
    form.resetFields();
  }, [isSuccessUpdate, form, isErrorUpdate, errorUpdate, showSuccessToast]);

  useEffect(() => {
    if (isErrorUpdatePoints) toast.error(errorUpdatePoints?.data?.detail, toastErrorStyle);

    if (isSuccessUpdatePoints) {
      showSuccessPointsUpdatedToast();
    }
  }, [isSuccessUpdatePoints, isErrorUpdatePoints, errorUpdatePoints, showSuccessPointsUpdatedToast]);

  useEffect(() => {
    if (isErrorDelete) toast.error(errorDelete?.data?.detail, toastErrorStyle);
    if (isSuccessDelete) {
      showSuccessActivityRemovedToast();
    }
  }, [isSuccessDelete, isErrorDelete, errorDelete, showSuccessActivityRemovedToast]);

  // these values never change so the calllback is not going to be ever re-created
  const switchEditing = useCallback(
    () => setIsEditingPuntosPosibles(!isEditingRef.current),
    [isEditingRef, setIsEditingPuntosPosibles],
  );

  const handleSave = (row: IActivity) => {
    let tempArr = actividadesPuntosPosibles;

    tempArr = actividadesPuntosPosibles.map((act) =>
      act.actividadId !== row?.actividadId ? act : row,
    );
    setActividadesPuntosPosibles(tempArr);
  };

  const deleteActivity = (record: IActivity) => {
    modal.confirm({
      title: `¿Esta seguro(a) de que desea remover la actividad ${record.actividadNombre}?`,
      icon: <Icon name="" color="#FFC53D" />,
      okText: "Remover",
      onOk: () => {
        deleteCourseActivity(record.actividadId);
      },
      cancelText: "Cancelar",
      style: { top: 200 },
    });
  };

  const submitActivity = (d: IActivity) => {
    if (!d.actividadMoodleId && !actividadId) {
      toast.error("Debe asociar una actividad de Moodle", toastWarningStyle);
    } else {
      const data = { ...d, seccionId };
      if (actividadId) updateActivity({ ...data, id: actividadId });
      else createActivity(data);
      setActividadId(0);
    }
  };

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setCourseDetailPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    
    getCourseDetailPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setCourseDetailPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setCourseDetailPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  const activitiesColumns = React.useMemo<ColumnsType<IActivity>>(
    () => [
      {
        title: "",
        dataIndex: "isAssigned",
        width: 40,
        render: (value) =>
          value ? (
            <Icon name="" size={20} colorPrimary />
          ) : (
            <Icon name="" size={20} color="#A7A7A7" />
          ),
      },
      {
        title: courseDetailPage?.activity_list?.activity_name || "Título",
        dataIndex: "actividadNombre",
        width: 250,
      },
      {
        title: courseDetailPage?.activity_list?.activity_type || "Tipo de actividad",
        dataIndex: "actividadTipoNombre",
        width: 220,
      },
      {
        title: () =>
          editable ? (
            <FlexStyled>
              {courseDetailPage?.activity_list?.possible_point || "Puntos posibles"} {" "}
              <Button
                size="small"
                type="text"
                icon={<Icon name="" color="#A7A7A7" />}
                onClick={switchEditing}
              />
            </FlexStyled>
          ) : (
            courseDetailPage?.activity_list?.possible_point || "Puntos posibles"
          ),
        dataIndex: "puntosPosibles",
        width: 100,
        editable: true,
        fieldType: "number",
      },
      {
        title: "",
        dataIndex: "actionsGrades",
        fixed: "right",
        width: 30,
        render: (_, record) =>
          totalPuntosPosibles == 100 ? (
            <Button
              type="text"
              title={courseDetailPage?.activity_list?.calification || "Calificaciones"}
              icon={<Icon name="" outlined color="#A7A7A7" />}
              onClick={() =>
                navigate(`/teacher/courses/activity-grades/${record.actividadId}/${seccionId}`)
              }
            />
          ) : null,
      },
      {
        title: "",
        dataIndex: "actions",
        fixed: "right",
        width: 30,
        render: (_, record) =>
          !record.estaCalificada && editable ? (
            <Dropdown
              overlayClassName="table-dropdown"
              className="cursor-pointer"
              key={record.actividadId}
              trigger={["click"]}
              align={{ offset: [-40, 4] }}
              menu={{
                items: [
                  {
                    key: "1",
                    label: "Editar",
                    icon: <Icon name="" color="#A7A7A7" />,
                    onClick: () => {
                      setActividadId(record.actividadId);
                    },
                  },
                  {
                    key: "2",
                    label: "Remover",
                    icon: <Icon name="" color="#A7A7A7" />,
                    onClick: () => deleteActivity(record),
                  },
                ],
              }}
            >
              <Icon name="" isTouchable />
            </Dropdown>
          ) : null,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editable, totalPuntosPosibles, courseDetailPage],
  );
  const columns = activitiesColumns.map((col: any) => {
    return {
      ...col,
      onCell: (record: IActivity) => ({
        record,
        fieldType: col.fieldType,
        options: col.options,
        editable: col.editable && isEditingPuntosPosibles && !record.estaCalificada && editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  
  if (hasError && locale === 'en') {
    return <StrapiError 
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setCourseDetailPage(null);
      }}
    />;
  }

  return (
    <Spin spinning={isLoadingContent} tip="Cargando contenido...">
      <SectionTitle>{courseDetailPage?.activity_list?.activity_title || "Actividades"}</SectionTitle>
      <CardStyled>
        <FlexFiltersContainer>
          <Form.Item label={courseDetailPage?.activity_list?.activity_type || "Tipo de actividad"}>
            <Select
              options={tiposActividades}
              allowClear
              placeholder={courseDetailPage?.activity_list?.activity_type || "Tipo de actividad"}
              onChange={(e) => setTipoIdFiltro(e)}
            />
          </Form.Item>
          <Form.Item label={courseDetailPage?.activity_list?.search_label || "Búsqueda de actividad"}>
            <Input
              allowClear
              placeholder={courseDetailPage?.activity_list?.search_input || "Búsqueda"}
              onChange={(e) => setTituloFiltro(e.target.value)}
            />
          </Form.Item>
          <Button
            onClick={() => navigate(`/teacher/courses/course-grades/${seccionId}/grades-historial`)}
          >
            {courseDetailPage?.activity_list?.history_calification_changes || "Historial de cambios de calificaciones"}
          </Button>
          {editable && (
            <Button
              type="primary"
              onClick={() => setDrawerActivitiesOpen(true)}
              loading={isLoadingCreate || isLoadingUpdate || isLoadingById || isLoadingUpdatePoints}
            >
              {courseDetailPage?.activity_list?.new_activity || "Nueva actividad"}
            </Button>
          )}
          {isEditingPuntosPosibles && (
            <Button
              onClick={() => updatePoints({ actividades: actividadesPuntosPosibles })}
              loading={isLoadingCreate || isLoadingUpdate || isLoadingById || isLoadingUpdatePoints}
            >
              {courseDetailPage?.activity_list?.save_button || "Guardar cambios"}
            </Button>
          )}
        </FlexFiltersContainer>
        <Table<IActivity>
          components={editableComponents}
          locale={{
            emptyText: (
              <Box>
                <Box>
                  <SmallHeadingStyled>{courseDetailPage?.activity_list?.empty_message || "No se encontraron actividades"}</SmallHeadingStyled>
                  <Image
                    src={NoResultsSVG}
                    preview={false}
                    alt="Ilustración sin resultados"
                    width={200}
                  />
                </Box>
              </Box>
            ),
          }}
          pagination={false}
          size="small"
          loading={isLoading || isLoadingDelete || isLoadingUpdatePoints}
          columns={columns}
          dataSource={actividadesPuntosPosibles}
          rowKey={(v) => v.actividadId}
          scroll={{ x: 500 }}
        />

        <Flex
          style={{
            gap: "67%",
            padding: 10,
            margin: "5px 0px 15px 0px",
            color: "#00479B",
            fontWeight: "bold",
            backgroundColor: "#F4F6FA",
          }}
        >
          <span>{courseDetailPage?.activity_list?.total_points || "PUNTOS TOTALES:"}</span>
          <span>{totalPuntosPosibles}</span>
        </Flex>
        {data?.actividades?.length > 0 && totalPuntosPosibles < 100 && (
          <Alert
            type="warning"
            message={courseDetailPage?.activity_list?.total_point_message || "La sumatoria de puntos posibles en las actividades no satisfacen el 100%"}
            style={{ marginBottom: 5 }}
          />
        )}
      </CardStyled>
      <MediumDrawer
        placement="right"
        title={actividadId !== 0 ? courseDetailPage?.activity_list?.edit_activity || "Edición de actividad" : courseDetailPage?.activity_list?.new_activity || "Nueva actividad"}
        open={drawerActivitiesOpen}
        size="large"
        onClose={() => {
          setActividadId(0);
          form.resetFields();
          setDrawerActivitiesOpen(false);
        }}
      >
        {" "}
        <Form
          form={form}
          layout="vertical"
          ref={formRef}
          onFinish={submitActivity}
          style={{ display: "flex", flexDirection: "column", gap: 16 }}
          initialValues={{
            id: 1,
          }}
        >
          <Collapse
            defaultActiveKey={[1]}
            activeKey={actividadId > 0 ? [1] : undefined}
            items={[
              {
                key: 1,
                label: (
                  <SmallHeadingStyled style={{ margin: 0 }}>{courseDetailPage?.activity_list?.general_data || "Datos generales"}</SmallHeadingStyled>
                ),
                children: (
                  <div>
                    {" "}
                    <Form.Item
                      name="actividadNombre"
                      label={courseDetailPage?.activity_list?.activity_name || "Título"}
                      hasFeedback
                      required
                      rules={[
                        {
                          required: true,
                          message: courseDetailPage?.activity_list?.required_field || "Este campo es requerido.",
                        },
                        {
                          max: 30,
                          message: courseDetailPage?.activity_list?.activity_maximum_caracteres || "El título no puede tener más de 30 caracteres.",
                        },
                      ]}
                    >
                      <Input type="text" />
                    </Form.Item>
                    <Form.Item
                      name="tipoActividadId"
                      label="Tipo"
                      required
                      rules={[
                        {
                          required: true,
                          message: courseDetailPage?.activity_list?.required_field || "Este campo es requerido.",
                        },
                      ]}
                    >
                      <Select
                        loading={isLoadingById}
                        options={valoresDefaultTipos}
                        allowClear
                        placeholder={courseDetailPage?.activity_list?.select_activity_type || "Seleccionar tipo de actividad"}
                      />
                    </Form.Item>
                    <Form.Item
                      name="descripcion"
                      label={courseDetailPage?.activity_list?.activity_description || "Descripción"}
                      hasFeedback
                      required
                      rules={[
                        {
                          required: true,
                          message: courseDetailPage?.activity_list?.required_field || "Este campo es requerido.",
                        },
                      ]}
                    >
                      <TextArea />
                    </Form.Item>
                    <Form.Item
                      name="puntosPosibles"
                      label={courseDetailPage?.activity_list?.possible_point || "Puntos posibles"}
                      required
                      rules={[
                        {
                          required: true,
                          message: courseDetailPage?.activity_list?.required_field || "Este campo es requerido.",
                        },
                      ]}
                    >
                      <InputNumber min={0} max={100} controls={false} />
                    </Form.Item>
                  </div>
                ),
              },
              {
                key: 2,
                collapsible: actividadId > 0 ? "disabled" : "header",
                label: (
                  <SmallHeadingStyled style={{ margin: 0 }}>
                    Información de Moodle
                  </SmallHeadingStyled>
                ),
                children: (
                  <div>
                    <Form.Item
                      name="tipoMoodleId"
                      label={courseDetailPage?.activity_list?.type_recurso || "Tipo de recurso"}
                      required={actividadId == 0}
                      rules={[
                        {
                          required: actividadId == 0,
                          message: courseDetailPage?.activity_list?.required_field || "Este campo es requerido.",
                        },
                      ]}
                    >
                      <Select
                        loading={isLoadingById}
                        options={valoresDefaultRecursos}
                        onChange={(e) => setRecursoMoodle(e)}
                        allowClear
                        placeholder={courseDetailPage?.activity_list?.select_recurso_type || "Seleccionar tipo de recurso"}
                      />
                    </Form.Item>
                    <Form.Item
                      name="seccionMoodleId"
                      label={courseDetailPage?.activity_list?.section_week || "Sección/Semana"}
                      required={actividadId == 0}
                      rules={[
                        {
                          required: actividadId == 0,
                          message: courseDetailPage?.activity_list?.required_field || "Este campo es requerido.",
                        },
                      ]}
                    >
                      <Select
                        loading={isLoadingById}
                        options={valoresDefaultSemanas}
                        onChange={(e) => setSeccionMoodle(e)}
                        allowClear
                        placeholder={courseDetailPage?.activity_list?.select_section || "Seleccionar sección"}
                      />
                    </Form.Item>
                    <Form.Item
                      name="actividadMoodleId"
                      label={courseDetailPage?.activity_list?.asociate_activity || "Actividad a asociar"}
                      required={actividadId == 0}
                      rules={[
                        {
                          required: actividadId == 0,
                          message: courseDetailPage?.activity_list?.required_field || "Este campo es requerido.",
                        },
                      ]}
                    >
                      <Select
                        options={activitiesMoodleOptions}
                        placeholder={courseDetailPage?.activity_list?.select_activity || "Seleccionar actividad"}
                        filterOption={filterOption}
                        showSearch
                        optionFilterProp="children"
                        allowClear
                        loading={isLoadingActivitiesMoodle || isLoadingById}
                      />
                    </Form.Item>
                    <ButtonAlternativeStyled
                      size="small"
                      disabled={seccionMoodle == 0 || recursoMoodle == ""}
                      loading={isLoadingMoodleUrl}
                      onClick={() => {
                        setOldMoodleActivityList(activitiesMoodle);
                        window.open(moodleUrl);
                      }}
                    >
                      {courseDetailPage?.activity_list?.activity_create || "Crear actividad"}
                    </ButtonAlternativeStyled>
                  </div>
                ),
              },

              // {
              //   key: 4,
              //   label: (
              //     <SmallHeadingStyled style={{ margin: 0 }}>Disponibilidad</SmallHeadingStyled>
              //   ),
              //   children: (
              //     <div>
              //       {" "}
              //       <Form.Item name="esSiempreDisponible" valuePropName="checked" hasFeedback>
              //         <Checkbox checked>Siempre disponible</Checkbox>
              //       </Form.Item>
              //       {!campoSiempreDisponible ? (
              //         <Form.Item
              //           name="disponibilidad"
              //           label="Disponibilidad"
              //           hasFeedback
              //           required={!campoSiempreDisponible}
              //           rules={[
              //             {
              //               required: !campoSiempreDisponible,
              //               message: "Este campo es requerido.",
              //             },
              //           ]}
              //         >
              //           <DatePicker.RangePicker
              //             placeholder={["Fecha inicio", "Fecha fin"]}
              //             showTime={{ format: "HH:mm" }}
              //             format="YYYY-MM-DD HH:mm"
              //             onChange={(value, dateString) => {
              //               console.log("Selected Time: ", value);
              //               console.log("Formatted Selected Time: ", dateString);
              //             }}
              //           />
              //         </Form.Item>
              //       ) : null}
              //     </div>
              //   ),
              // },
            ]}
          ></Collapse>

          <Button
            type="primary"
            size="large"
            htmlType="submit"
            style={{ alignSelf: "flex-end" }}
            loading={isLoading || isLoadingCreate || isLoadingUpdate}
          >
            {courseDetailPage?.activity_list?.save_button || "Guardar"}
          </Button>
        </Form>
      </MediumDrawer>
      {contextHolder}
    </Spin>
  );
}

export default ActivitiesList;
